var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropdown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolationsmodus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.89 261.05",
    style: {
      enableBackground: "new 0 0 325.89 261.05"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.8,99.22c-11.65,17.17-23.3,34.34-34.95,51.46c-10.12,14.93-20.23,29.86-30.41,44.73c-4.81,7.11-9.57,14.33-14.49,21.38 c-0.33,0.49-0.66,0.93-1.04,1.42c1.15-1.48,2.3-2.95,3.45-4.43c-0.93,1.09-1.86,2.02-3.01,2.9c1.48-1.15,2.95-2.3,4.43-3.45 c-1.09,0.82-2.24,1.48-3.45,2.02c1.75-0.71,3.5-1.48,5.25-2.19c-1.42,0.6-2.9,1.04-4.43,1.26c1.91-0.27,3.88-0.55,5.8-0.77 c-1.75,0.22-3.45,0.22-5.2,0c1.91,0.27,3.88,0.55,5.8,0.77c-1.53-0.27-2.95-0.66-4.43-1.26c1.75,0.71,3.5,1.48,5.25,2.19 c-1.26-0.55-2.35-1.26-3.45-2.02c1.48,1.15,2.95,2.3,4.43,3.45c-1.09-0.88-2.08-1.86-3.01-2.9c1.15,1.48,2.3,2.95,3.45,4.43 c-4.59-5.91-8.53-12.41-12.69-18.59c-9.62-14.22-19.25-28.38-28.93-42.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.38,45.4c-0.27-1.91-0.55-3.88-0.77-5.8c0.16,1.48,0.16,2.95,0,4.43c0.27-1.91,0.55-3.88,0.77-5.8 c-0.22,1.53-0.6,3.01-1.2,4.43c0.71-1.75,1.48-3.5,2.19-5.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.2,45.84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.21,46.39c0.71,0,1.42,0.05,2.13,0.11c-1.91-0.27-3.88-0.55-5.8-0.77c1.59,0.22,3.06,0.6,4.54,1.15 c-1.75-0.71-3.5-1.48-5.25-2.19c1.37,0.6,2.68,1.31,3.88,2.24c-1.48-1.15-2.95-2.3-4.43-3.45c1.15,0.93,2.19,1.91,3.12,3.06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.88,46.39h0.44c11.43,0,22.42-10.06,21.88-21.88c-0.66-11.87-9.73-21.88-21.98-21.88l0,0h-52.06H126.74H49.19H42.9 c-14.05,0.05-28,7.38-34.67,20.07c-6.67,12.58-6.84,28.27,1.26,40.3c1.26,1.91,2.57,3.77,3.83,5.63 c15.48,22.75,30.9,45.55,46.38,68.31c18.37,27.02,36.69,54.09,55.07,81.1c4.54,6.67,9.02,13.29,13.56,19.96 c5.85,8.64,13.34,15.48,23.68,18.21c10.12,2.73,21.88,1.37,30.79-4.32c5.58-3.61,9.19-7.55,12.96-12.96 c11.87-17.01,23.3-34.34,35-51.52c19.36-28.49,38.66-56.98,58.02-85.42c6.89-10.12,13.73-20.23,20.62-30.41 c6.34-9.3,12.36-17.88,12.09-30.08c-0.22-10.23-4.27-19.96-11.38-27.29c-7.33-7.49-17.55-11.38-27.89-11.59 c-11.43-0.22-22.42,10.23-21.88,21.88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.06,46.93c1.2-0.88,2.46-1.64,3.88-2.24c-1.75,0.71-3.5,1.48-5.25,2.19c1.48-0.55,2.95-0.93,4.54-1.15 c-1.91,0.27-3.88,0.55-5.8,0.77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.38,46.55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.58,45.84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4,45.4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4,38.24"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.41,37.42"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropdown.bd94f9b467aaec762a683561964194ae.svg";